import getCityList from './getCityList';

export default {
  getCityList,
};
